import "./About.css";
import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";

export default function About() {
  const { openSidebar } = useCart();

  return (

    <>

      {/* Large Logo Section - Same as Home Page */}
      <div style={{
        position: 'fixed',
        top: '16px',
        left: '24px',
        zIndex: 999,
        display: 'flex',
        alignItems: 'center'
      }}>
        <Link
          to="/"
          style={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.filter = 'drop-shadow(0 0 20px rgba(0, 255, 255, 0.4))';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.filter = 'none';
          }}
        >
        </Link>
      </div>

      {/* Section 1 - Hero Intro */}
      <section className="about-hero">
        <div className="about-hero-container">
          <div className="about-hero-header">
            <h1 className="about-hero-title">About Chilltree</h1>
            <div className="about-hero-underline"></div>
            <p className="about-hero-subtitle">Premium wellness products crafted with care and backed by science.</p>
          </div>
          <div className="about-hero-content">
          </div>
        </div>
      </section>

      {/* Section 2 - Brand Story */}
      <section className="about-brand-story">
        <div className="about-brand-container">
          <div className="about-brand-content">
            <div className="about-brand-left">
              <div className="about-mission-section">
                <h2 className="about-section-title">Our Mission</h2>
              </div>
              
              <div className="about-philosophy-section">
                <h2 className="about-section-title">Product Philosophy</h2>
                <p className="about-brand-text">
                  Every product we create is small-batch crafted using naturally sourced ingredients, carefully selected for their proven benefits. We harness the power of adaptogens, nootropics, and botanical extracts to deliver clean, sustained energy without the crash. Our commitment to natural energy means you can trust what you're putting into your body, knowing it's been rigorously tested and verified.
                </p>
              </div>
              
              <div className="about-transparency-section">
                <h2 className="about-section-title">Transparency Promise</h2>
                <p className="about-brand-text">
                  Quality isn't just a promise—it's our foundation. From sourcing the finest ingredients to third-party lab testing every batch, we ensure that every Chilltree product meets our exacting standards. We're transparent about our process, our ingredients, and our results, because you deserve to know exactly what you're consuming and why it works.
                </p>
              </div>
            </div>
            
            <div className="about-brand-right">
              <div className="about-why-card">
                <h3 className="about-why-title">Why Chilltree</h3>
                <div className="about-why-list">
                  <div className="about-why-item">
                    <div className="about-why-icon">🌿</div>
                    <div className="about-why-content">
                      <h4>Natural Ingredients</h4>
                      <p>Sourced from nature, crafted for performance</p>
                    </div>
                  </div>
                  <div className="about-why-item">
                    <div className="about-why-icon">🔬</div>
                    <div className="about-why-content">
                      <h4>Lab-Tested Formulas</h4>
                      <p>Third-party verified for purity and potency</p>
                    </div>
                  </div>
                  <div className="about-why-item">
                    <div className="about-why-icon">⚡</div>
                    <div className="about-why-content">
                      <h4>Clean, Focused Energy</h4>
                      <p>Sustained performance without the crash</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3 - Core Values */}
      <section className="about-values">
        <div className="about-values-container">
          <h2 className="about-values-title">Our Core Values</h2>
          <div className="about-values-grid">
            <div className="about-value-card">
              <div className="about-value-icon">
                <span>⭐</span>
              </div>
              <h3 className="about-value-name">Quality</h3>
              <p className="about-value-desc">
                We source only the finest natural ingredients and subject every batch to rigorous third-party testing to ensure purity, potency, and safety.
              </p>
            </div>

            <div className="about-value-card">
              <div className="about-value-icon">
                <span>🔍</span>
              </div>
              <h3 className="about-value-name">Transparency</h3>
              <p className="about-value-desc">
                Complete openness about our ingredients, processes, and lab results. Every product comes with full documentation so you know exactly what you're getting.
              </p>
            </div>

            <div className="about-value-card">
              <div className="about-value-icon">
                <span>⚡</span>
              </div>
              <h3 className="about-value-name">Performance</h3>
              <p className="about-value-desc">
                Scientifically formulated blends that deliver real results. Clean, sustained energy, enhanced focus, and natural recovery—without the crash or jitters.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Founder Section */}
      <section className="founder-section">
        <div className="founder-container">
          <div className="founder-content">
            <div className="founder-image">
              <img src="/chilltree-images/chill-tree-gold.png" alt="Founder" />
            </div>
            <div className="founder-info">
              <h2 className="founder-title">Meet Our Founder</h2>
              <h3 className="founder-name">Sarah Chen</h3>
              <p className="founder-bio">
                After years in the wellness industry, Sarah saw a critical gap: natural energy solutions that actually work. Frustrated with artificial ingredients and empty promises, she spent three years researching botanical formulations and working with nutrition experts to create Chilltree. Her vision was simple: harness nature's power to deliver clean, sustained energy without compromise.
              </p>
              <div className="founder-quote">
                "I believe that what you put in your body matters. That's why I'm committed to creating products that are not only effective but also transparent, natural, and trustworthy."
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Brand Timeline */}
      <section className="brand-timeline">
        <div className="timeline-container">
          <h2 className="timeline-title">Our Journey</h2>
          <div className="timeline-items">
            <div className="timeline-item">
              <div className="timeline-year">2021</div>
              <div className="timeline-content">
                <h3>The Beginning</h3>
                <p>Research and development begins in our home lab</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">2022</div>
              <div className="timeline-content">
                <h3>First Formulation</h3>
                <p>Perfecting our signature botanical energy blend</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">2023</div>
              <div className="timeline-content">
                <h3>Launch</h3>
                <p>Chilltree launches with our flagship energy shots</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">2024</div>
              <div className="timeline-content">
                <h3>Growth</h3>
                <p>Expanding our product line and customer community</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="final-cta">
        <div className="cta-container">
          <h2 className="cta-title">Ready to Experience Natural Energy?</h2>
          <p className="cta-subtitle">Join thousands who've made the switch to clean, botanical energy</p>
          <div className="cta-buttons">
            <Link to="/products" className="cta-primary-btn">Shop Products</Link>
            <button onClick={openSidebar} className="cta-secondary-btn" type="button">View Cart</button>
          </div>
        </div>
      </section>

    </>

  );

}




